import { ReactElement } from "react";
import { RegisterOptions } from "react-hook-form";

export const AgreementField = ({
  register,
  errors,
}: {
  register: (ref: string, options: RegisterOptions) => any;
  errors: Record<string, any>;
}): ReactElement => {
  return (
    <div className="field">
      <div className="checkboxes">
        <label>
          <input type="checkbox" data-test="input-agreement" {...register("agreement", { required: true })} />
          <span>
            <a href="/aud/terms_of_use" target="_blank">
              利用規約
            </a>
            と
            <a href="/privacy_policy" target="_blank">
              プライバシーポリシー
            </a>
            を確認し同意します
          </span>
        </label>
      </div>
      {errors.agreement && <span className="sub red">利用規約とプライバシーポリシーへの同意が必要です</span>}
    </div>
  );
};
